<div class="cb-sidebar-items" [ngClass]="['cb-theme-' + theme(), 'cb-size-' + size()]" [class.cb-compact]="compact()">
  @let item = navItem();
  <div class="cb-sidebar-item" [cbTooltip]="(compact())? (item.label ?? '' | translate) : ''"
    routerLinkActive="cb-current" [class.cb-open]="isOpen()" (isActiveChange)="activationChanged($event)" [routerLink]="
      item.type === 'route' || item.type === 'subview'
        ? item.routerLink
        : null
    " (click)="clickSidebar()">
    <div class="cb-sidebar-item-content">
      @if (item.icon) {
      <cb-icon [name]="item.icon"></cb-icon>
      }
      @if(!compact()){
      <p>
        {{ item.label ?? "" | translate }}
      </p>
      }
    </div>
    @if (item.type === "collapsible") {
    <cb-icon [name]="'cb-base-outline-' + (isOpen() ? 'chevronup' : 'chevrondown')"></cb-icon>
    }
  </div>
  @if (item.type === "collapsible" && isOpen()) {
  @for (item of item.items; track $index) {
  <cb-nav-item (activationChange)="activationChanged($event)" [size]="size()" [navItem]="item"></cb-nav-item>
  }
  }
</div>